<ng-container *ngIf="globalSearchService.isExpanded$ | async">
    <div class="global-search-bar" [@slide]>
        <div class="global-search-bar-container container-fluid page-container">
            <form
                [formGroup]="formGroup"
                (ngSubmit)="handleSearchFormSubmit()"
                class="global-search-form"
            >
                <lsq-radio-list
                    formControlName="searchBy"
                    name="global-search-by"
                    [vertical]="false"
                    [options]="[
                        {
                            id: 'global-search-by' + searchByInvoiceNumberKey,
                            label: 'Invoice #',
                            value: searchByInvoiceNumberKey
                        },
                        {
                            id: 'global-search-by' + searchByCheckNumberKey,
                            label: 'Check #',
                            value: searchByCheckNumberKey
                        }
                    ]"
                >
                </lsq-radio-list>
                <lsq-input
                    formControlName="search"
                    name="global-search-term"
                    [maxLength]="maxSearchLength"
                >
                </lsq-input>

                <!-- This input allows enter-to-submit to work. -->
                <input type="submit" [style.display]="'none'" />
            </form>
        </div>
    </div>
</ng-container>
